import { render, staticRenderFns } from "./TambahRole.vue?vue&type=template&id=2845f248&scoped=true"
import script from "./TambahRole.vue?vue&type=script&lang=js"
export * from "./TambahRole.vue?vue&type=script&lang=js"
import style0 from "./TambahRole.vue?vue&type=style&index=0&id=2845f248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845f248",
  null
  
)

export default component.exports